/************
 Product Swiper
 ************/

// setup product swiper
const productSwiper = new Swiper(document.querySelector(".productVisualSwiper"), {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
        nextEl: document.querySelector('.productVisualSwiperNext'),
        prevEl: document.querySelector('.productVisualSwiperPrev'),
    },
    pagination: {
        el: document.querySelector('#productVisualPag'),
        clickable: true
    },
    on: {
        slideChange: function () {
            // pause all videos
            document.querySelectorAll(".productVisualSwiperSlide video")?.forEach(element => {
                element.pause();
            });
        }
    }
});


// play video on slide play click
document.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
    element.addEventListener("click", function () {
        // get video
        const video = this.closest(".productVisualSwiperSlide").querySelector("video");

        if (!video) {
            return;
        }

        // remove play button if it hasn't already been removed
        this.querySelector(".productVisualSwiperSlidePlay")?.remove();

        // show controls
        video.controls = true;

        // play video
        video.play();
    });
});

// listen for input changes
document.querySelectorAll('.productSellingLabelInput').forEach(element => {
    element.addEventListener("change", function () {
        updateProduct();
    })
})

function updateProduct() {

    let total = activeVariant.price;
    let compareAtPrice = activeVariant.compare_at_price;

    // if subscription
    if (document.querySelector('.productSellingLabelInput:checked')?.value === "sub") {
        total = activeVariant.selling_plan_allocations[0].price;
        compareAtPrice = activeVariant.selling_plan_allocations[0].compare_at_price;
    }

    // update ATC price
    document.querySelector('.productATCPriceRealCompare').textContent = '';

    document.querySelector('.productATCPriceReal').textContent = price(total, true);
    if (compareAtPrice > total) {
        document.querySelector('.productATCPriceRealCompare').textContent = price(compareAtPrice, true);
    }


}

updateProduct();

/**************
 Product ATC
 ***************/

document.querySelector("#productATC").addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    let formData = {
        items: [{
            quantity: 1,
            id: parseInt(document.querySelector("#productATC").dataset.id),
        }]
    };

    // if subscription, add selling plan id to form data
    if (document.querySelector('.productSellingLabelInput:checked')?.value === "sub") {
        formData.items[0].selling_plan = parseInt(document.querySelector('.productSellingLabelBodyBottomWrapContentSelect').value);
    }

    // add product
    await addProduct(formData);

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});

// font fix override for shopify payments (make b element normal weight)
document.addEventListener("DOMContentLoaded", async function () {
    customElements.whenDefined("shopify-payment-terms").then(() => {
        customElements.whenDefined("shop-pay-installments-banner").then(() => {
            // the element is absent on products without installments, so bail out rather than throw
            const bannerBold = document.querySelector("shopify-payment-terms")?.shadowRoot?.querySelector("shop-pay-installments-banner")?.shadowRoot?.querySelector("b");
            if (!bannerBold) {
                return;
            }
            bannerBold.style = "font-weight: 400;";
        });
    });
});
